import { useQuery } from "@tanstack/react-query";
import { httpClient, ROOT_URL } from "../App";

export const useGetWorldCheckCountries = () => {
  return useQuery<{ data: [] }>([`/v1/worldCheck/countries`], async () =>
    getWorldCheckCountries()
  );
};

export function getWorldCheckCountries() {
  return httpClient.get(`${ROOT_URL}/api/v1/worldCheck/countries`);
}
